/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDetails_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailReference_viewer">;
    readonly " $refType": "PdpRespDetails_viewer";
};
export type PdpRespDetails_viewer$data = PdpRespDetails_viewer;
export type PdpRespDetails_viewer$key = {
    readonly " $data"?: PdpRespDetails_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDetails_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDetails_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReference_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '1f55427459e18656ea41c4f15694649d';
export default node;
